export const SITE = {
  name: 'Yorkshire Development',
  shortName: 'YD',
  tagline: 'Web design & hosting from Yorkshire',
  description:
    'Hand-built websites and managed hosting from Yorkshire. Fast, accessible, properly maintained — for British businesses and beyond.',
  url: 'https://yorkshire-development.com',
  email: 'contact@yorkshire-development.com',
  phone: '+44 7908 595355',
  phoneHref: 'tel:+447908595355',
  founded: 2026,
} as const;
